<template>
  <div>
    <!-- 订单详情 -->
    <el-dialog
      :close-on-click-modal="false"
      title="订单详情"
      :visible.sync="visible"
      top="6vh"
      width="1100px"
      class="editDialog"
      :before-close="handleClose"
    >
      <div class="order-info-box">
        <div class="fl">
          <b>订单号： </b>
          {{ orderData.order.appNo }}
        </div>
        <div class="fl">
          <b>平台渠道： </b>
          {{ dictMap["plat_no"][orderData.order.platNo] }}
        </div>
        <div class="fl" style="width: 35%">
          <b>店铺账号： </b>
          {{ orderData.order.shopName }}
        </div>
        <div class="fl" style="width: 15%">
          <b>订单状态： </b>
          {{ dictMap["order_status"][orderData.order.orderStatus] }}
        </div>
      </div>
      <br />
      <el-tabs v-model="activeTab" type="card" @tab-click="handleClickTab">
        <el-tab-pane label="订单信息" name="order"></el-tab-pane>
        <el-tab-pane label="收货信息" name="deliver"></el-tab-pane>
        <el-tab-pane label="物流信息" name="logis"></el-tab-pane>
        <el-tab-pane label="订单动态" name="orderRecord"></el-tab-pane>
      </el-tabs>
      <div style="max-height: 54vh; overflow: auto">
        <div class="order-card" id="edit_order">
          <div class="title">订单信息</div>
          <div v-if="orderData.progress" class="content">
            <el-steps :active="activeStatus">
              <el-step
                :title="item.name"
                :description="item.time"
                v-for="(item, index) in orderData.progress"
                :key="index"
              >
              </el-step>
              <!-- <el-step
                title="待付货款"
                :description="orderData.order.createTime"
              ></el-step>
              <el-step
                title="已付款"
                :description="orderData.order.payTime"
              ></el-step>
              <el-step title="排单中"></el-step>
              <el-step title="生产中"></el-step> -->
            </el-steps>
          </div>
          <div class="content">
            <div class="buyer-detail">
              <div class="flex1">
                买家账号： {{ orderData.addr.buyerEmail }}
              </div>
              <div class="flex1">买家姓名： {{ orderData.addr.buyerName }}</div>
              <div class="flex1">
                来源国家：<span v-if="orderData.order.amazonSite">
                  {{ dictMap["amazon_site"][orderData.order.amazonSite] }}</span
                >
              </div>
            </div>
            <el-table
              :data="orderData.order.skuList"
              border
              style="width: 100%"
            >
              <el-table-column width="529" label="产品信息">
                <template slot-scope="scope">
                  <div class="table-info-wrap">
                    <div class="table-info">
                      <div class="left">
                        <img
                          class="mini-img"
                          :src="scope.row.picUrl ? scope.row.picUrl : noImage"
                        />
                      </div>
                      <div class="right">
                        <div
                          :title="scope.row.amazonProductName"
                          class="text-ellipsis"
                        >
                          {{ scope.row.amazonProductName }}
                        </div>
                        <div :title="scope.row.itemSku" class="text-ellipsis">
                          {{ scope.row.itemSku }}
                        </div>
                        <div v-if="scope.row.proName">
                          {{ scope.row.proName }}
                          <span v-if="scope.row.designId">
                            ({{ scope.row.designId }})</span
                          >
                        </div>
                        <div v-if="scope.row.properName">
                          <span
                            v-if="scope.row.properName && scope.row.properVal"
                          >
                            <span
                              v-for="(i, ind) in [0, 1]"
                              :key="'i_' + ind"
                              style="margin-right: 10px"
                            >
                              {{ scope.row.properName.split(":")[i] }}：
                              {{ scope.row.properVal.split(":")[i] }}
                            </span>
                          </span>
                        </div>
                        <div>数量：{{ scope.row.num || "-" }}</div>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="单价" width="100">
                <template slot-scope="scope">
                  {{ dictMap["currency_mark"][orderData.order.currency] }}
                  {{ scope.row.salePrice }}
                </template>
              </el-table-column>
              <el-table-column prop="address" label="货款" width="100">
                <template slot-scope="scope">
                  ￥
                  {{ scope.row.proPrice == null ? "-" : scope.row.proPrice }}
                </template>
              </el-table-column>
              <el-table-column
                prop="embroideryPrice"
                label="刺绣单价"
                width="100"
              >
                <template slot-scope="scope">
                  ￥
                  {{
                    scope.row.embroideryPrice == null
                      ? "-"
                      : scope.row.embroideryPrice
                  }}
                </template>
              </el-table-column>
              <el-table-column prop="num" label="数量"> </el-table-column>
              <el-table-column
                prop="address"
                label="操作"
                width="100"
                v-if="canEdit"
              >
                <template slot-scope="scope">
                  <div class="operate">
                    <span
                      v-if="
                        (orderData.order.productType === '01' ||
                          orderData.order.productType == null) &&
                          ['01', '06', '09'].includes(
                            orderData.order.orderStatus
                          ) &&
                          user.userType !== '00'
                      "
                      class="link"
                      @click="handleEdit(scope.row)"
                    >
                      修改
                    </span>
                    <span
                      v-if="
                        orderData.order.productType === '01' &&
                          ['01', '06', '09'].includes(
                            orderData.order.orderStatus
                          ) &&
                          scope.row.skuId &&
                          user.userType !== '00'
                      "
                      class="link"
                      @click="divide(scope.row)"
                    >
                      拆分
                    </span>
                    <span
                      v-if="
                        orderData.order.skuList.length > 1 &&
                          ['01', '06', '09'].includes(
                            orderData.order.orderStatus
                          ) &&
                          user.userType !== '00'
                      "
                      class="link"
                      @click="deleteOrder(scope.row)"
                    >
                      删除
                    </span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="content flex">
            <div class="fl">
              <b>销售总计： </b>
              <span v-if="orderData.order.saleActPay !== null">
                {{ dictMap["currency_mark"][orderData.order.currency]
                }}{{ orderData.order.saleActPay }}
              </span>
              <span v-else>-</span>
            </div>
            <div class="fl">
              <b>产品金额： </b>
              <span v-if="orderData.order.saleTotal !== null">
                {{ dictMap["currency_mark"][orderData.order.currency]
                }}{{ orderData.order.saleTotal }}
              </span>
              <span v-else>-</span>
            </div>
            <div class="fl">
              <b>运费： </b>
              <span v-if="orderData.order.saleFare !== null">
                {{ dictMap["currency_mark"][orderData.order.currency]
                }}{{ orderData.order.saleFare }}
              </span>
              <span v-else>-</span>
            </div>
            <div class="fl" style="width: 25%;">
              <b>货款总计： </b>
              <span v-if="orderData.order.proActPay !== null">
                ￥{{ orderData.order.proActPay }}
              </span>
              <span v-else>-</span>
            </div>
            <div class="fl" style="width: 25%;">
              <b>产品货款： </b>
              <span v-if="orderData.order.proTotal !== null">
                ￥{{ orderData.order.proTotal }}
              </span>
              <span v-else>-</span>
            </div>
            <div class="fl" style="width: 25%;">
              <b>刺绣费用： </b>
              <span v-if="orderData.order.embroideryCost !== null">
                ￥{{ orderData.order.embroideryCost }}
              </span>
              <span v-else>-</span>
            </div>
            <div class="fl" style="width: 25%;">
              <b>运费： </b>
              <span v-if="orderData.order.proFare !== null">
                ￥{{ orderData.order.proFare }}
              </span>
              <span v-else>-</span>
            </div>
          </div>
        </div>
        <div class="order-card" id="edit_deliver">
          <div class="title">
            收货信息
            <div class="right" v-if="canEdit">
              <span
                v-if="
                  !deliverIsEdit &&
                    user.userType !== '00' &&
                    (orderData.order.orderStatus === '01' ||
                      orderData.order.orderStatus === '09')
                "
                @click="deliverIsEdit = true"
              >
                <i class="el-icon-edit-outline"></i>
                编辑
              </span>
              <span v-if="deliverIsEdit" @click="saveDeliver">
                <i class="el-icon-check"></i>
                保存
              </span>
              <!-- <span v-if="deliverIsEdit" @click="resetDeliver">
                <i class="el-icon-refresh-left"></i>
                重置
              </span> -->
              <span v-if="deliverIsEdit" @click="deliverIsEdit = false">
                <i class="el-icon-close"></i>
                取消
              </span>
            </div>
          </div>
          <div class="content flex">
            <div class="fl w50">
              <b>收件人： </b>
              <span v-if="!deliverIsEdit">{{ addr.receName }}</span>
              <el-input
                v-else
                v-model="addr.receName"
                class="input"
                size="small"
              />
            </div>
            <div class="fl w50">
              <b>国家： </b>
              <span v-if="!deliverIsEdit">{{
                dictMap["amazon_site"][addr.state]
              }}</span>
              <el-select
                clearable
                v-else
                v-model="addr.state"
                class="input"
                size="small"
              >
                <el-option
                  v-for="(value, index) in dictData['amazon_site']"
                  :key="index"
                  :label="value.label"
                  :value="value.value"
                >
                </el-option>
              </el-select>
            </div>
            <div class="fl w50">
              <b>省/州： </b>
              <span v-if="!deliverIsEdit">{{ addr.province }}</span>
              <span style="width: 100%" v-else>
                <el-select
                  v-if="addr.state === 'CN'"
                  clearable
                  value-key="code"
                  size="small"
                  v-model="addr.province"
                  placeholder="省"
                  @change="provinceChange"
                >
                  <el-option
                    v-for="item in provinceOptions"
                    :key="item.code"
                    :label="item.name"
                    :value="item"
                  >
                  </el-option>
                </el-select>
                <el-input
                  v-else
                  v-model="addr.province"
                  class="input"
                  size="small"
                />
              </span>
            </div>
            <div class="fl w50">
              <b>城市： </b>
              <span v-if="!deliverIsEdit">{{ addr.city }}</span>
              <span style="width: 100%" v-else>
                <el-select
                  v-if="addr.state === 'CN'"
                  clearable
                  value-key="code"
                  size="small"
                  v-model="addr.city"
                  placeholder="市"
                  @change="cityChange"
                >
                  <el-option
                    v-for="item in cityOptions"
                    :key="item.code"
                    :label="item.name"
                    :value="item"
                  >
                  </el-option>
                </el-select>
                <el-input
                  v-else
                  v-model="addr.city"
                  class="input"
                  size="small"
                />
              </span>
            </div>
            <div class="fl w50">
              <b>县市： </b>
              <span v-if="!deliverIsEdit">{{ addr.county }}</span>
              <span style="width: 100%" v-else>
                <el-select
                  v-if="addr.state === 'CN'"
                  clearable
                  value-key="code"
                  size="small"
                  v-model="addr.county"
                  placeholder="区"
                  @change="countyChange"
                >
                  <el-option
                    v-for="item in areaOptions"
                    :key="item.code"
                    :label="item.name"
                    :value="item"
                  >
                  </el-option>
                </el-select>
                <el-input
                  v-else
                  v-model="addr.county"
                  class="input"
                  size="small"
                />
              </span>
            </div>
            <div class="fl w50">
              <b>地址： </b>
              <span v-if="!deliverIsEdit">{{ addr.detailAddr }}</span>
              <el-input
                v-else
                v-model="addr.detailAddr"
                class="input"
                size="small"
              />
            </div>
            <div class="fl w50">
              <b>电话： </b>
              <span v-if="!deliverIsEdit">{{ addr.mobile }}</span>
              <el-input
                v-else
                v-model="addr.mobile"
                class="input"
                size="small"
              />
            </div>
            <div class="fl w50">
              <b>邮编： </b>
              <span v-if="!deliverIsEdit">{{ addr.zipCode }}</span>
              <el-input
                v-else
                v-model="addr.zipCode"
                class="input"
                size="small"
              />
            </div>
            <div class="fl w50"></div>
          </div>
        </div>
        <div class="order-card" id="edit_logis">
          <div class="title">
            物流信息
            <div class="right" v-if="orderData.order.orderStatus == '01'">
              <span
                @click="handleSelectShip(orderData)"
                style="color: #409eff; cursor: pointer"
                >{{
                  orderData.expre && orderData.shippingMethod
                    ? "修改物流方式"
                    : "选择物流方式"
                }}</span
              >
            </div>
          </div>
          <div class="content flex">
            <el-table :data="orderData.expre" class="exchange-table">
              <el-table-column prop="shippingMethodName" label="物流方式">
              </el-table-column>
              <el-table-column prop="trackingNumber" label="物流单号">
              </el-table-column>
              <el-table-column prop="sendTime" label="发货时间">
                <template slot-scope="scope">
                  {{ scope.row.departedTime }}
                </template>
              </el-table-column>
              <el-table-column prop="发货产品" label="发货产品">
                <template slot-scope="scope">
                  <a
                    v-if="scope.row.shipList && scope.row.shipList.length > 0"
                    style="cursor: pointer"
                    @click="handleShowDetail(scope.row)"
                    >详情</a
                  >
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <a style="cursor: pointer" @click="handleShowExpre(scope.row, orderData.order)"
                    >查看物流进度</a
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="order-card" id="edit_orderRecord">
          <div class="title">订单动态</div>
          <div class="content">
            <div
              class="step"
              v-if="orderData.process && orderData.process.length > 0"
            >
              <el-steps direction="vertical" :active="orderData.process.length">
                <el-step
                  :title="item.operLink"
                  v-for="(item, index) in orderData.process"
                  :key="index"
                >
                  <div slot="description">
                    <p>{{ item.operTime }}</p>
                    <p>{{ item.operNote }}</p>
                  </div>
                </el-step>
              </el-steps>
            </div>
            <div v-else>暂无</div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          v-if="
            orderData.order.orderStatus === '01' &&
              canEdit &&
              user.userType !== '00' &&
              showPayButton
          "
          type="primary"
          @click="goPay"
          size="small"
        >
          立即付款
        </el-button>
        <el-button type="primary" @click="sure" size="small"> 关闭 </el-button>
      </span>
    </el-dialog>

    <ExpreDetail
      @onClose="handleCloseExpre"
      :detail="detail"
      :visible="expreVisible"
    ></ExpreDetail>

    <!-- 手续费设置弹窗 -->
    <DivideOrder
      :visible="divideModal"
      @onClose="hideDivideOrder"
      :order="currentOrder"
      :currentOrderSku="localOrderSku"
    />

    <!-- 修改订单设置弹窗 -->
    <ModifyOrder
      :visible="showModifyOrder"
      @onClose="handleCloseMoidfyOrder"
      :order="currentOrder"
      :currentOrderSku="currentOrderSku"
    />

    <!-- 选择快递弹窗 -->
    <SelectShip
      :orderData="orderData.order"
      :visible="showShip"
      @onClose="hideShip"
    />
    <el-dialog
      title="产品列表"
      :visible.sync="detailVisible"
      width="60%"
      :before-close="handleCloseDetail"
    >
      <el-table :data="productList" class="exchange-table">
        <el-table-column prop="shippingMethodName" label="主题名称">
          <template slot-scope="scope">
            <a style="cursor: pointer" @click="handleOpenProduct(scope.row)">{{
              scope.row.proName
            }}</a>
          </template>
        </el-table-column>
        <el-table-column prop="color" label="颜色"> </el-table-column>
        <el-table-column prop="size" label="尺码"> </el-table-column>
        <el-table-column prop="quantity" label="数量"> </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="handleCloseDetail"
          >关 闭</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import DivideOrder from "./DivideOrder"
import { mapGetters } from "vuex"
import {
  editAddr,
  editSku,
  changeSku,
  getOrderDetail,
  deleteSku,
  editExpre,
} from "@/api/order/all"
import { getCartInfo, getCartMatchInfo } from "@/api/customProduct/design"
import ModifyOrder from "./ModifyOrder"
import noImage from "@/assets/images/no_image.png"
import SelectShip from "./SelectShip"
import { selectExpreList, getExpreProcess } from "@/api/order/all"
import ExpreDetail from "./ExpreDetail"

export default {
  name: "EditOrder",
  components: {
    DivideOrder,
    ModifyOrder,
    SelectShip,
    ExpreDetail,
  },
  data() {
    return {
      updateModal: false,
      divideModal: false,
      showModifyOrder: false,
      currentOrder: {
        properName: "",
        properVal: "",
      },
      activeTab: "order",
      deliverIsEdit: false,
      showShip: false,
      activeStatus: 1,
      innerOrder: {},
      currentOrderSku: {
        attribute: "",
      },
      localOrderSku: {
        attribute: "",
      },
      provinceOptions: [],
      cityOptions: [],
      areaOptions: [],
      addr: {
        receName: "",
        country: "",
        province: "",
        city: "",
        detailAddr: "",
        buyerPhoneNumber: "",
        zipCode: "",
      },
      noImage: noImage,
      detailVisible: false,
      productList: [],
      expreList: [],
      detail: {},
      expreVisible: false,
      orderData: {
        order: {
          appNo: "",
        },
        expre: {
          shippingMethod: "",
          trackingNumber: "",
          createTime: "",
        },
        addr: {
          receName: "",
          country: "",
          province: "",
          city: "",
          detailAddr: "",
          buyerPhoneNumber: "",
          zipCode: "",
        },
      },
    }
  },
  props: {
    visible: {
      type: Boolean,
      default() {
        return false
      },
    },
    canEdit: {
      type: Boolean,
      default() {
        return true
      },
    },
    appId: {
      type: String,
      default() {
        return ""
      },
    },
    orderDetail: {
      type: Object,
      default() {
        return {
          order: {
            appNo: "",
          },
          expre: {
            shippingMethod: "",
            trackingNumber: "",
            createTime: "",
          },
          addr: {
            receName: "",
            country: "",
            province: "",
            city: "",
            detailAddr: "",
            buyerPhoneNumber: "",
            zipCode: "",
          },
        }
      },
    },
  },
  watch: {
    visible: {
      handler() {
        if (this.visible) {
          this.orderData = this._.clone(this.orderDetail)
          this.getData()
          this.addr = this._.clone(this.orderData.addr)
          this.deliverIsEdit = false
          this.loadProvData()
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters(["dictData", "dictMap", "user"]),
    showPayButton() {
      let permission = JSON.stringify(this.$store.state.permission)
      return permission.indexOf("GetPay") !== -1
    },
  },
  methods: {
    handleCloseExpre() {
      this.expreVisible = false
    },
    async handleShowExpre(detail, row) {
      this.expreVisible = true
      detail.appId = row.appId
      detail.appNo = row.appNo
      let result = await getExpreProcess({ expreId: detail.expreId })
      this.expreList = result
      this.detail = detail
    },
    // 获取省市区数据
    loadProvData() {
      $.ajax({
        url: process.env.BASE_URL + "areaData.json",
        method: "get",
        success: (res) => {
          this.provinceOptions = res["regionalDivision"]

          this.provinceOptions.forEach((item) => {
            if (item.name == this.addr.province) {
              this.cityOptions = item.city
              this.provinceOptions.forEach((item) => {
                if (item.name == this.addr.province) {
                  this.cityOptions = item.city
                  this.cityOptions.forEach((item) => {
                    if (item.name == this.addr.city) {
                      this.areaOptions = item.district
                    }
                  })
                }
              })
            }
          })
        },
      })
    },
    provinceChange(val) {
      this.cityOptions = []
      this.provinceOptions.forEach((item) => {
        if (item.code == val.code) {
          this.cityOptions = item.city
        }
      })
      this.addr.province = val.name
      //清空值
      this.addr.city = undefined
      this.addr.county = undefined
      //不为空时,市和县默认赋值第一个
      if (this.cityOptions.length > 0) {
        this.addr.city = this.cityOptions[0].name
        this.cityChange(this.cityOptions[0])
      }
    },
    // 城市下拉修改
    cityChange(val) {
      this.areaOptions = []
      this.cityOptions.forEach((item) => {
        if (item.code == val.code) {
          this.areaOptions = item.district
          return
        }
      })
      this.addr.city = val.name

      if (this.areaOptions.length > 0) {
        this.addr.county = this.areaOptions[0].name
      }
    },
    // 区县下拉修改
    countyChange(val) {
      this.addr.county = val.name
    },
    hideShip() {
      this.refreshOrder()
      this.showShip = false
    },
    handleOpenProduct(row) {
      let routeUrl = ""
      if (row.productType == "01") {
        routeUrl = this.$router.resolve({
          path: "/select/custom/product",
          query: { designId: row.designId },
        })
      } else {
        routeUrl = this.$router.resolve({
          path: "/select/custom/product",
          query: { pId: row.pId },
        })
      }

      window.open(routeUrl.href, "_blank")
    },
    getData() {
      const map = {
        "01": 1,
        "02": 2,
        "03": 3,
        "04": 4,
        "05": 5,
      }
      this.orderData.order
        ? (this.activeStatus = map[this.orderData.order.orderStatus])
        : ""
      this.innerOrderData = Object.assign({}, this.orderData)
      this.orderData.order.addr = this.orderData.addr
    },
    sure() {
      this.$emit("onClose")
    },
    handleClose() {
      this.$emit("onClose")
    },
    handleCloseDetail() {
      this.detailVisible = false
    },
    async handleEdit(data) {
      // if (this.orderData.order && this.orderData.order.productType !== "01") {
      //   this.$message.info("只有定制产品才能修改哦～")
      //   return false
      // }
      this.currentOrder = Object.assign({}, data)
      if (data.designId) {
        try {
          let result = await getCartMatchInfo(data.designId)
          this.showModifyOrder = true
          this.currentOrderSku = result.data[0]
        } catch (error) {
          this.showModifyOrder = true
          this.currentOrderSku = {}
        }
      } else {
        this.showModifyOrder = true
        this.currentOrderSku = {}
      }
    },
    handleSelectShip(orderData) {
      if (!(orderData.addr && orderData.addr.receName)) {
        this.msgError("请填写收货信息")
        return
      }
      this.showShip = true
    },
    handleUpdateClose() {},
    async refreshOrder() {
      let result = await getOrderDetail(this.appId)
      this.orderData = result.data
    },
    changeProper(data, index) {
      // let skuId = ""
      // let pId = ""
      // let properName = ""
      // const properVal0 = this.currentOrder.properVal.split(":")[0]
      // const properVal1 = this.currentOrder.properVal.split(":")[1]
      // let newProperVal = ""
      // if (index === 0) {
      //   newProperVal = data + ":" + properVal1
      // }
      // if (index === 1) {
      //   newProperVal = properVal0 + ":" + data
      // }
      // this.currentOrderSku.skuList.map((el) => {
      //   if (el.properVal === newProperVal) {
      //     skuId = el.skuId
      //     pId = el.pId
      //     properName = el.properName
      //   }
      // })
      // this.currentOrder.properVal = newProperVal
      // this.currentOrder.skuId = skuId
      // this.currentOrder.properName = properName
      // this.currentOrder.pId = pId
    },
    sureChange() {
      this.updateModal = false

      changeSku(this.currentOrder)
        .then((res) => {
          if (res.code === 200) {
            this.$emit("onUpdate", this.appId)
            this.$message.success("保存成功")
          }
        })
        .catch((error) => {
          this.$message.error(error.msg)
        })
    },
    sureUpdate() {
      this.updateModal = false

      editSku(this.currentOrder)
        .then((res) => {
          if (res.code === 200) {
            this.$emit("onUpdate", this.appId)
            this.$message.success("保存成功")
          }
        })
        .catch((error) => {
          this.$message.error(error.msg)
        })
    },
    handleCloseMoidfyOrder() {
      this.refreshOrder()
      this.showModifyOrder = false
    },
    divide(data) {
      this.currentOrder = data
      getCartMatchInfo(data.designId).then((res) => {
        this.divideModal = true
        this.localOrderSku = res.data
      })
    },
    hideDivideOrder() {
      this.$emit("onUpdate", this.appId)
      this.divideModal = false
    },
    hideModifyOrder() {
      this.$emit("onUpdate", this.appId)
      this.divideModal = false
    },
    handleShowDetail(record) {
      this.productList = record.shipList
      this.detailVisible = true
    },
    deleteOrder(record) {
      this.$confirm("请确认是否删除所选产品？", "删除产品", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        await deleteSku(record.appSkuId)
        this.$emit("onUpdate", this.appId)
        this.refreshOrder()
        this.$message({
          type: "success",
          message: "删除成功!",
        })
      })
    },
    handleClickTab(value) {
      this.$el.querySelector(`#edit_${value.name}`).scrollIntoView({
        behavior: "smooth", // 平滑过渡
        block: "start", // 上边框与视窗顶部平齐。默认值
      })
    },
    goPay() {
      let shipFlag = true

      if (!this.orderData.expre || this.orderData.expre.length == 0) {
        shipFlag = false
      } else {
        for (let record of this.orderData.expre) {
          if (!record.shippingMethod) {
            shipFlag = false
          }
        }
      }
      let platNo = this.orderData.order.platNo

      if (
        (platNo == "03" || platNo == "05") &&
        !this.orderData.order.attachId
      ) {
        this.$message.error("请上传面单再进行付款")
        return false
      }
      if (
        this.orderData.addr &&
        (!this.orderData.addr.state ||
          !this.orderData.addr.mobile ||
          !this.orderData.addr.receName)
      ) {
        this.$message.error("收件地址没有填写正确，请填写再付款")
        return false
      }

      if (!shipFlag) {
        this.$message.error("没有选择物流方式，不能支付货款")
        return false
      }
      this.$router.push({
        path: "/order/myOrder/getPay",
        query: {
          id: this.orderData.order.appNo,
        },
      })
    },
    // 保存地址
    async saveDeliver() {
      this.addr.appId = this.appId
      let result = await editAddr(this.addr)
      if (result.code !== 200) {
        this.$message.error("保存地址失败")
      } else {
        this.$message.success("保存地址成功")
        await editExpre([{
          shippingMethod: "",
          appId: this.appId,
          proFare: 0,
        }])
        this.deliverIsEdit = false
        this.refreshOrder()
      }
    },
    // 重置
    resetDeliver() {
      this.addr = Object.assign({}, this.inneraddr)
    },
  },
}
</script>

<style scoped lang="scss">
.center {
  text-align: center;
}

.editDialog {
  font-size: 12px;

  .el-tabs__header {
    margin-bottom: -1px;
  }

  .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
    border-bottom-color: #f5f7fa;
    background: #f5f7fa;
  }
}

.order-info-box {
  background: #f5f7fa;
  width: 100%;
  box-sizing: border-box;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  border: 1px solid #ebeef5;
  flex-wrap: wrap;

  .fl {
    width: 25%;
  }
}

.order-card {
  margin-bottom: 10px;
  border: 1px solid #ebeef5;

  .title {
    background: #f5f7fa;
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
    font-weight: bold;
    border-bottom: 1px solid #ebeef5;
    position: relative;

    .right {
      position: absolute;
      right: 10px;
      color: #409eff;
      top: 12px;
      display: flex;
      align-items: center;

      span {
        display: inline-block;
        margin-left: 10px;
        cursor: pointer;
      }
    }
  }

  .content {
    width: 100%;
    padding: 20px 10px;
    box-sizing: border-box;
    border-bottom: 1px solid #ebeef5;

    &:last-child {
      border: 0;
    }
  }
}

.order-card .content.flex {
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 10px;
  flex-wrap: wrap;

  .fl {
    width: 33.33%;
    margin: 2px auto;
    display: flex;
    align-items: center;
    height: 32px;

    b {
      width: 80px;
      text-align: right;
    }
  }
}

.w33 {
  width: 33.33% !important;
}

.w50 {
  width: 50% !important;
}

.table-info-wrap {
  margin-bottom: -10px;
}

.table-info {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 10px;
  padding: 0 10px;

  &:last-child {
    margin-bottom: 0;
    border-bottom: 0;
  }

  .left {
    margin-right: 12px;
    width: 100px;
    min-height: 100px;
    margin-bottom: 10px;

    .mini-img {
      width: 95px;
      height: 95px;
      border: 1px solid #ebeef5;
    }

    .id {
      width: 100%;
      text-align: center;
    }
  }
  .right {
    width: 400px;
    padding: 0 0 8px 0;
  }
}

.operate {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.link {
  font-size: 12px;
  color: #1e7ec8;
  cursor: pointer;
}

.step {
  min-height: 300px;
  display: flex;
}

.step {
  .el-steps--vertical {
    width: 100%;
  }
}

.updateDialog {
  display: flex;

  .left {
    width: 100px;
    height: 100px;
    margin-right: 10px;
    border: 1px solid #ebeef5;
  }
}

.updateDialog .left img {
  width: 100%;
  height: 100%;
}

.updateDialog .right {
  display: flex;
  flex-direction: column;

  .title {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .list {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    .name {
      width: 80px;
    }

    .value {
      width: 100%;
    }
  }
}

#edit_order ::v-deep .el-step {
  flex-basis: 300px !important;
}

.buyer-detail {
  display: flex;
  margin: 0 0 16px 0;
}

.flex1 {
  flex: 1;
}
</style>
